import { Tooltip } from "@src/components/elements";
import { UserNameType, userName } from "@src/utils/userName";
import React from "react";

type Props = {
  user: UserNameType;
  className?: string;
};

export const UserName = ({ user, className }: Props) => {
  const username = userName(user);

  if (user?.firstName && user?.lastName) {
    return (
      <Tooltip title={user.email} showWithoutOverflow={true}>
        <span className={className}>{username}</span>
      </Tooltip>
    );
  }

  if (!username) {
    return <span className={className}>No username available</span>;
  }

  return <span className={className}>{username}</span>;
};
